<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form ref="searchForm">
					<c-form-item type="hidden" name="stationed_id"></c-form-item>
					<c-form-item type="input" label="所属经销商" name="company_name" readonly @click="$refs.stationedSelector.open(2)"></c-form-item>
					<c-form-item type="input" label="订单号" name="order_number"></c-form-item>
					<c-form-item type="input" label="代理手机号" name="user_manage_mobilephone"></c-form-item>
					<c-form-item type="input" label="会员昵称" name="nick_name"></c-form-item>
					<c-form-item type="input" label="业务员姓名" name="salesman_realname"></c-form-item>
					<c-form-item type="input" label="商品名称" name="product_name" placeholder="模糊匹配"></c-form-item>
					<c-form-item type="input" label="收货人" name="receiving_name"></c-form-item>
					<c-form-item type="input" label="收货人电话" name="receiving_phone"></c-form-item>
                    <c-form-item type="input" label="运单号" name="logistics_number" placeholder="模糊匹配"></c-form-item>
                    <c-form-item type="datetime" label="下单时间" start-name="start_date" end-name="end_date"></c-form-item>
					<c-form-item type="datetime" label="付款时间" start-name="pay_start_date" end-name="pay_end_date"></c-form-item>
					<c-form-item type="checkbox" label="订单类型" name="order_type" :options="orderType"></c-form-item>
					<c-form-item type="checkbox" label="审核状态" name="check_state" :options="checkState"></c-form-item>
					<c-form-item type="checkbox" label="订单状态" name="order_state" :options="orderState"></c-form-item>
				</c-form>
			</m-search>
			<c-table ref="table">
				<c-table-column
					type="selector"
				></c-table-column>
				
				<c-table-column
					label="订单号"
					name="order_number"
					width="120"
				>
					<template v-slot="{data}">
						<a class="s-link" style="text-decoration: underline;" @click="navigateTo(`/order_detail/${data.order_number}`)">{{data.order_number}}</a>
					</template>
				</c-table-column>
				
				<c-table-column
					label="经销商名称"
					name="stationed_name"
					width="150"
				></c-table-column>
				
				
				<c-table-column
					label="订单类型"
					name="order_type"
					width="80"
				>
					<template v-slot="{data}">
						<span v-if="data.order_type==1" style="color:#888888">{{orderTypeName[data.order_type]}}</span>
						<span v-if="data.order_type==2" style="color:#ff00ff">{{orderTypeName[data.order_type]}}</span>
						<span v-if="data.order_type==3" style="color:#000000">{{orderTypeName[data.order_type]}}</span>
						<span v-if="data.order_type==4" style="color:#ff0000">{{orderTypeName[data.order_type]}}</span>
						<span v-if="data.order_type==5" style="color:#707070">{{orderTypeName[data.order_type]}}</span>
						<span v-if="data.order_type==6" style="color:#aaaa00">{{orderTypeName[data.order_type]}}</span>
						<span v-if="data.order_type==7" style="color:#0000ff">{{orderTypeName[data.order_type]}}</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="订单来源"
					name="order_source"
					width="80"
				>
					<template v-slot="{data}">
						{{orderSourceName[data.order_source]}}
					</template>
				</c-table-column>
				
				<c-table-column
					label="审核状态"
					name="check_state"
					width="80"
				>
					<template v-slot="{data}">
						<template v-if="data.payment_state == 1">
							<span v-if="data.payment_type=='转账支付'" style="color:#182eff">待审核</span>
							<span v-else style="color:#bbbbbb">--</span>
						</template>
						<template v-else>
							<span v-if="data.check_state==1 && data.order_state != 6" style="color:#182eff">待审核</span>
							<span v-if="data.check_state==1 && data.order_state == 6" style="color:#bbbbbb">--</span>
							<span v-if="data.check_state==2 && data.push_state == 1" style="color:#e1b504">审核通过</span>
							<span v-if="data.check_state==2 && (data.push_state == 0 || data.push_state == 2)" style="color:darkgreen">审核通过</span>
							<span v-if="data.check_state==3" style="color:#ff5555">不通过</span>
						</template>
					</template>
				</c-table-column>
				
				<c-table-column
					label="订单状态"
					name="order_state"
					width="90"
				>
					<template v-slot="{data}">
						<span v-if="data.order_state == 6" style="color:#999">{{orderStateName[data.order_state]}}</span>
						<span v-else-if="data.check_state==1 || data.check_state==3" style="color:#182eff">{{orderStateName[data.order_state]}}</span>
						<span v-else-if="data.check_state==2"> 
							<span v-if="data.refund_flag == 1" style="color: #ff5555">退款中</span>
							<span v-else-if="data.return_flag == 1" style="color: #ff5555">退货中</span>
							<span v-else>
								<span v-if="data.payment_state == 2" style="color:#708fff">待付尾款</span>
								<span v-else>
									<span v-if="data.order_state == 1" style="color:#182eff">{{orderStateName[data.order_state]}}</span>
									<span v-if="data.order_state == 2" style="color:#182eff">{{orderStateName[data.order_state]}}</span>
									<span v-if="data.order_state == 3" style="color:#69d39c">{{orderStateName[data.order_state]}}</span>
									<span v-if="data.order_state == 5" style="color:darkgreen">{{orderStateName[data.order_state]}}</span>
								</span>
							</span>
							<span v-if="data.order_state==3 && data.deliver_state=='部分发货'"><br/> (<span style="color:dodgerblue">{{ data.deliver_state}}</span>)</span>
						</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="会员名"
					name="user_login_name"
					width="140"
				></c-table-column>
				
				<c-table-column
					label="会员昵称"
					name="nick_name"
				></c-table-column>
				
				<c-table-column
					label="代理手机号"
					name="user_manage_mobilephone"
					width="120"
				></c-table-column>
				
				<c-table-column
					label="下单时间"
					name="create_date"
					width="150"
				></c-table-column>
				
				<c-table-column
					label="购买数量"
					name="product_count"
					width="80"
				></c-table-column>
				
				<c-table-column
					label="订单金额"
					name="product_money"
					width="180"
				>
				<template v-slot="{data}">
					<span v-if="data.order_type==2" style="color:#888888">
						{{data.product_money}}（积分）
					</span>
					<span v-if="data.order_type==2 && data.logistics_money > 0" style="color:orangered">
						(另运费￥{{parseFloat(data.logistics_money).toFixed(2)}})
					</span>
					<span v-if="data.order_type!=2 && data.payment_state != 3" style="color:#888888">
						￥{{parseFloat(data.product_money+data.custom_money+data.logistics_money + data.total_fee_money).toFixed(2)}}
					</span>
					<span v-if="data.order_type!=2 && data.payment_state == 3" style="color:darkgreen">
						￥{{parseFloat(data.payment_money).toFixed(2)}}
					</span>
					<span v-if="data.order_type!=2 && data.logistics_money > 0" style="color:orangered">
						(含运费￥{{parseFloat(data.logistics_money).toFixed(2)}})
					</span>
					<span v-if="data.order_type!=2 && data.total_fee_money > 0" style="color:orangered">
						<br/>(含服务费￥{{parseFloat(data.total_fee_money).toFixed(2)}})
					</span>
					<span v-if="data.order_type==7 && data.custom_money > 0" style="color:orangered">
						<br/>(含定制费￥{{parseFloat(data.custom_money).toFixed(2)}})
					</span>
				</template>
				</c-table-column>
				
				<c-table-column
					label="付款金额"
					name="payment_money"
					width="90"
				>
					<template v-slot="{data}">
						<span v-if="data.payment_money" style="color:darkgreen">
							￥{{parseFloat(data.payment_money).toFixed(2)}}
						</span>
						<span v-else style="color:#bbbbbb" >--</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="付款时间"
					name="payment_date"
					width="150"
				>
					<template v-slot="{data}">
						<span v-if="data.payment_date">
							{{data.payment_date}}
						</span>
						<span v-else style="color:#bbbbbb" >--</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="收货人"
					name="receiving_name"
					width="110"
				></c-table-column>
				
				<c-table-column
					label="收货人电话"
					name="receiving_phone"
					width="120"
				></c-table-column>
				
				<c-table-column
					label="配送方式"
					name="logistics_company_name"
					width="90"
				></c-table-column>
				
				<!-- <c-table-column
					label="是否到付"
					name="freight_payment_type"
					width="80"
				>
					<template v-slot="{data}">
						{{freightPaymentTypeName[data.freight_payment_type]}}
					</template>
				</c-table-column> -->
				
				<!-- <c-table-column
					label="备注"
					name="order_remark"
					width="110"
				>
					<template v-slot="{data}">
						<span v-if="data.order_remark">
							{{data.order_remark}}
						</span>
						<span v-else style="color:#bbbbbb" >--</span>
					</template>
				</c-table-column> -->
				
				<c-table-column
					label="发货时间"
					name="send_dates"
					width="150"
				>
					<template v-slot="{data}">
						<span v-if="data.send_dates">
                            <p v-for="(item, i) in data.send_dates.split(',')" style="margin-right: 10px;">{{item}}</p>
						</span>
						<span v-else style="color:#bbbbbb" >--</span>
					</template>
				</c-table-column>

				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="80"
				>
					<template v-slot="{data}">
						<c-table-button @click="navigateTo(`/order_detail/${data.order_number}`)">查看</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
		<stationed-selector ref="stationedSelector" @resolve="selectStationed"></stationed-selector>
	</page>
</template>

<script>
	import stationedSelector from '@/components/service/stationed_selector.vue'  // 商家库
	import {mapState} from 'vuex'
	export default {
		name: 'm_seller_order_sell',

		// 第二步：定义组件，导入了哪些就定义哪些
		components: {
			stationedSelector
		},

        props: {
            check_state: String,
            order_state: String,
            invoice_state: String,
            pay_state: String,
            reconciliation_state: String
        },

        data() {
			return {
				orderStateName: {
					1: '待付款',
					2: '待发货',
					3: '待收货',
					5: '交易完结',
					6: '已关闭'
				},
				orderTypeName: {
					1: '普通',
					2: '积分',
					4: '砍价',
					5: '预售订单(全款)',
					6: '预售订单(定金)',
					7: '定制',
          8: '拼团',
          9: '云仓提货',
          10: '送礼',
          11: '抽奖'
        },
				orderSourceName: {
					'OMS':'管理后台',
					'IOS': '苹果',
					'ANDROID': '安卓',
					'MINI': '小程序',
					'PC': 'PC电脑'
				},
				freightPaymentTypeName:{
					1: '运费先付',
					2: '运费到付'
				},
				orderState: [{
						name: '待付款',
						value: 1
					},{
						name: '待发货',
						value: 2
					},{
						name: '待收货',
						value: 3
					},{
						name: '交易完结',
						value: 5
					},{
						name: '已关闭',
						value: 6
					}
				],
				checkState: [{
						name: '待审核',
						value: 1
					},{
						name: '审核通过',
						value: 2
					},{
						name: '审核不通过',
						value: 3
					}
				]
			}
		},

        computed: {
			...mapState(['systemConfig']),
			
			orderType() {
				return (
					[{
						name: '普通',
						value: 1
					}].concat(this.systemConfig.points_system == 'ON'?[{
						name: '积分',
						value: 2
					}]:[])
					.concat(this.systemConfig.bargain_enabled == 'ON'?[{
						name: '砍价',
						value: 4
					}]:[])
					.concat(this.systemConfig.presell_enabled == 'ON'?[{
						name: '预售订单(全款)',
						value: 5
					}]:[])
					.concat(this.systemConfig.presell_enabled == 'ON'?[{
						name: '预售订单(定金)',
						value: 6
					}]:[])
					.concat(this.systemConfig.product_custom == 'ON'?[{
						name: '定制',
						value: 7
					}]:[])
                    .concat([{
                        name: '拼团',
                        value: 8
                    }])
				);
			},
			
            defaultSearch() {
                let param = {
                    check_state: this.check_state ? this.check_state.split(',') : [],
                    order_state: this.order_state ? this.order_state.split(',') : [],
                    invoice_state: this.invoice_state ? this.invoice_state.split(',') : [],
                    reconciliation_state: this.reconciliation_state? this.reconciliation_state.split(',') : [],
                }

                if (this.pay_state == 1) {
                    param.pay_start_date = new Date().format('yyyy-MM-dd') + ' 00:00:00';
                    param.pay_end_date = new Date().format('yyyy-MM-dd') + ' 23:59:59';
                }

                return param;
            }
        },

        watch: {
            defaultSearch(val) {
                this.$refs.searchForm.set(val);
                this.$nextTick(() => {
                    this.$refs.search.search();
                })
            }
        },

        mounted() {
            this.$refs.searchForm.set(this.defaultSearch);
            this.$nextTick(() => {
                this.$refs.search.search();
            })
            this.$bus.$on('order.update', data => {
                // 刷新列表
                this.$refs.table.update();
            });
        },


		methods: {
			//搜索
			searchHandle(data) {
				data.stationed_type = 2;
				this.searchDate = data;
				this.$refs.table.load({
					url: '/order/list',
					data
				});
			},
			selectStationed(data) {
				this.$refs.searchForm.set({
					stationed_id: data[0].id,
					company_name: data[0].company_name
				});
			}
		}
	}
</script>
<style lang="stylus" scoped>	
	.order {
		&-verify {
			padding: 20px;
			
			textarea {
				box-sizing: border-box;
				width: 100%;
				height: 120px;
				border: none;
				padding: 10px 14px;
				line-height: 20px;
				background: #FAFAFA;
				resize: none;
			}
		}
	}
	
	.invoice {
		padding: 5px 10px;
		box-sizing: border-box;
		
		p {
			font-weight: bold;
			margin-bottom: 30px;
			font-size: 15px;
		}
	}
</style>